const MODULE = 'OTHER_FEE_QUANTITY'
export const GET_QUANTITY_CALCULATION_LIST = `${MODULE}/get_quantity_calculation_list`;
export const QUANTITY_CALCULATION_INFO = `${MODULE}/quantity_calculation_info`;
export const CREATE_QUANTITY_FEES = `${MODULE}/create_quantity_fees`;
export const UPDATE_QUANTITY_FEES = `${MODULE}/update_quantity_fees`;
export const REMOVE_QUANTITY_FEES = `${MODULE}/remove_quantity_fees`;
export const GET_NEW_OTHER_FEES = 'NEW_OTHER_FEES/get_new_other_fees';
export const GET_SINGLE_NEW_OTHER_FEES =
  'NEW_OTHER_FEES/get_single_new_other_fees';

export const FORM_DATA = {
  multiplier: '',
  amount: ''
};


